import AbstractChannel from './AbstractChannel'

export default class Honk extends AbstractChannel {

  name = 'honk'
  title = 'Honk'
  titleShort = 'Honk'
  color = '#FFBB78'

}
